import React, {
    useState,
    useEffect,
    useRef,
} from 'react';
import { useSelector } from 'react-redux';
import instance from '../../../../helpers/axiosInstance';
import { Link,useNavigate } from 'react-router-dom';
import Search from '../../../../assets/Iconsearch.svg';
import Calandar from '../../../../assets/Icondate.svg';
import FraudFilter from '../../../../assets/fraud-icon.png';
import AllFilter from '../../../../assets/filter-icon.png';
import DataGridPagination from '../../../global/dataGridPagination';
// import Moment from 'react-moment';
import moment from 'moment';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Popover from 'react-bootstrap/Popover';
import greenPhone from '../../../../assets/green-phone-image.svg';
import redPhone from '../../../../assets/red-phone-image.svg';
import yellowPhone from '../../../../assets/yellow-phone-image.svg';
import blackPhone from '../../../../assets/black-phone-image.svg';
// import actionButton from '../../../../assets/action-button.png';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import FilterMenu from "../../../global/filterComponent/FilterMenu";
import CallStatus from '../../../global/popupModal/CallStatus';
import { filterOptions } from './filterObj';
import './newOrder.scss';
import { commonServiceMethod } from '../../../../helpers/helper';
import Loader from '../../../global/loader';
import SuccessToast from '../../../customToast/SuccessToast';
import { Slide, toast } from 'react-toastify';
// import CloseIcon from '../../../../assets/close -Icon.png';
import { Popup } from '../../../global/popupModal/BottomDialog';

import FraudFilterYellow from '../../../../assets/alert-triangle-yellow.svg';
import FraudFilterGreen from '../../../../assets/alert-triangle-green.svg';
import FraudFilterRed from '../../../../assets/alert-triangle-red.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const UnLabledBody = () => {
    let navigate = useNavigate();
    const userClaim = useSelector((state) => state.user);
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [originalData, setOriginalData] = useState({});
    const [selectedObject, setSelectedObject] = useState([]);
    const [open, setOpen] = useState(false);

    // pagination and Filtr variables 
    const per_page = 50;
    const [pageNo, setPageNo] = useState(1);
    // moment().subtract(30, 'days').toDate(), moment().toDate()
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').toDate())
    const [endDate, setEndDate] = useState(moment().toDate());
    const [searchText, setSearchText] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const [loader, setLoader] = useState(false);
    // const [callRowID, setCallRowID] = useState('');
    const [popupData, setPopupData] = useState({ popupName: "", data: "", callBackMethod: null })
    const [searchParam, setSearchParam] = useState("");
    const [columnData, setComlumnData] = useState([]);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        //console.log(isOpen);
    };

    const [fraudval, setFraudVal] = useState("");

    const [preSelectedOption, setPreSelectedOption] = useState({})
    const [refreshData, setRefreshData] = useState(1);
    
    const checkFraudAlert = (param) => {
        let a = JSON.parse(param.data?.fraud_data || '{}'), fraudVAlue = "";
        let fraud = [a?.customerCancel?.alert || 0, a?.frequency?.alert || 0, a?.order?.alert || 0, a?.repeat?.alert || 0];
        switch (fraud.filter(i => i === 1).length) {
            case 0:
                fraudVAlue = FraudFilterGreen;
                break;
            case 1:
                fraudVAlue = FraudFilterYellow;
                break;
            case 2:
                fraudVAlue = FraudFilterRed;
                break;
            default:
                fraudVAlue = FraudFilterRed;
                break;
        }
        return fraudVAlue
    }

    let columnDefsWithCall = [
        {
            headerName: 'Order Id',
            field: 'order_name',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            wrapText: true,
            autoHeight: true,
            width: 180,
            cellClass: "check-box-container order-number",
            cellRenderer: (param) => {
                let fraud = checkFraudAlert(param)
                let tags = param.data?.tag ? param.data?.tag.split(",") : false;
                return (<div>
                    <Link className='grid-link' to={`/orders/all-order/order-details/${btoa(param.data?.order_id)}`}>{param.value}</Link>
                    <img src={fraud} style={{ marginLeft: "5px" }} />
                    <p className='logo'>{tags && tags.map((i, k) => <span key={k} className={`order-tag-status ${k + 1 !== tags.length && 'mb-2'}`}>{i?.toLowerCase()}</span>)}</p>
                </div>)
            }
        },
        {
            field: 'app_order_status',
            width: 100,
            wrapText: true,
            autoHeight: true,
            headerName: 'Order Status',
            cellClass: "app-order-status",
            cellRenderer: (params) => {
                let order_status_class = "";
                if (params.value.toLowerCase() === "cancel") {
                    order_status_class = "cancel";
                } else if (params.value.toLowerCase() === "refunded") {
                    order_status_class = "refund";
                } else if (params.value.toLowerCase() === "delivered") {
                    order_status_class = "delivered";
                } else {
                    order_status_class = "";
                }
                return (<span className={`default-status ${order_status_class}`}>
                    {params.value}
                </span>)
            }
        },
        {
            width: 180,
            field: 'shipping_address',
            wrapText: true,
            autoHeight: true,
            headerName: 'Recipient',
            cellClass: "d-flex-center customers",
            cellRenderer(params) {
                let address = params.data?.shipping_address;
                return (
                    <div className="address-wrap">
                        <p className="customer-name">
                            {params.data?.customer_name}
                        </p>
                        <p className="address">
                            {params.data?.customer_email}
                        </p>
                        <p className="address">
                            {address.phone ? address.phone : ''}
                        </p>
                        <p className="address">
                            {address.city ? address.city : ''} - {address.zip ? address.zip : ''}
                        </p>
                    </div>
                )
            }
        },
        {
            field: 'callStatus',
            width: 170,
            wrapText: true,
            autoHeight: true,
            headerName: 'Call Status',
            cellRenderer(param) {
                let img, text;
                switch (param.value) {
                    case "accepted":
                        img = greenPhone;
                        text = "Order Accepted ";
                        break;
                    case "declined":
                        img = redPhone;
                        text = param.data?.reason_text || "Order Declined";
                        break;
                    case "other":
                        img = yellowPhone;
                        text = param.data?.reason_text || "";
                        break;
                    default:
                        img = blackPhone;
                        text = "";
                        break;
                }
                return (<div className='call-status-block'>

                    <span onClick={() => showModal('Call', param?.data, handleCallStatusChange)} className='call-count-status'>
                        <img alt='call status' src={img} />
                        {param.data?.callCount > 0 && <span className='count'>{param.data?.callCount}</span>}
                    </span>
                    <p to={''} className={`btn btn-sm btn-primary ${param.value}`} onClick={() => showModal('CallUpdate', param?.data, handleStatusChange)}>{param.value || "Select Status"}</p>
                    {text !== "" && <p className={`status-text ${param.value}`}>{text}</p>}
                </div>)
            }
        },
        {
            headerName: 'Order Total',
            field: 'total_price',
            width: 100,
            cellClass: "d-flex-center",
            cellRenderer(params) {
                let payment_mode = "";
                let payment_status = "";
                if (params.data?.gateway === "Cash on Delivery (COD)") {
                    payment_mode = "COD";
                    payment_status = "info";
                } else {
                    payment_mode = "Pre-paid";
                    payment_status = "success";
                }
                return (
                    <div className='address-wrap'>
                        <p className="price_tag">{"Rs. " + params.value}</p>
                        <p className="price_tag">
                            <span className={payment_status}>{payment_mode}</span>
                        </p>
                    </div>
                )
            }
        },
        {
            field: 'carrier_name',
            width: 150,
            wrapText: true,
            autoHeight: true,
            headerName: 'Dimension & Weight',
            cellClass: "dimention",
            cellRenderer() {
                return (<>
                    Dim:10*10*10<br />
                    Weight:50gm<br />
                    <span className='edit-link'>Edit</span>
                </>)
            }
        },
        {
            width: 100,
            field: 'order_created_at',
            wrapText: true,
            autoHeight: true,
            headerName: 'Order Date',
            cellClass: 'order-date',
            cellRenderer(param) {
                return (<span className={`order-date`}>{moment(param.value).format("MMM DD, YYYY hh:mm")}</span>)
            }
        },
        {
            width: 100,
            field: 'sku',
            wrapText: true,
            autoHeight: true,
            headerName: 'Item SKU',
            cellClass: 'sku-item',
            cellRenderer(param) {
                return (<span className={`status-value ${param.value}`}>{param.value}</span>)
            }
        },

        {
            width: 190,
            field: 'product_name',
            wrapText: true,
            autoHeight: true,
            headerName: 'Item Name',
            cellClass: 'product-name',
            cellRenderer(param) {
                return (<span title={param.value} className={`status-value`}>{param.value}</span>)
            }
        },
    ];

    useEffect(() => {
        if (userClaim.token !== "") {
            // getData(fraudval, pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText, searchParam);
            setComlumnData([...columnDefsWithCall]);
        }
    }, [userClaim]);

    const onClearFilter = () => {
        setSearchText("");
        setSearchParam("");
        toggleDropdown();
        // getData(fraudval, pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), "", "");
        navigate(`${location.pathname}`);
    }
    const showModal = (popupName, data, callBackMethod) => {

        // //console.log(string, value);
        // setCallDetails(string);
        // setCallRowID(value)
        setPopupData({ popupName, data, callBackMethod })
    }

    const closeModal = () => {
        // setCallDetails('');
        setPopupData({ popupName: "", data: "", callBackMethod: null });
    }


    const handleStatusChange = (val, obj) => {
        //console.log(val, obj)
        setCallStatus(val, obj);
    }

    const setCallStatus = async (status, item) => {
        let url = `app/order/update/callStatus`;
        let obj = {};
        obj.order_id = item.order_id;
        obj.status = status.status;
        obj.reason_text = status.other;
        try {
            setLoader(true);
            await instance.put(url, obj).then((res) => {
                if (res.status === 200 && res?.data?.message === "Update order sucessfully") {
                    closeModal();
                    setRefreshData((prev)=>prev+ 1);
                    // let e= document.querySelector("[data-startDate]");
                    // getData(fraudval, e.getAttribute('data-pageNo'), e.getAttribute('data-startdate') , e.getAttribute('data-endDate'), searchText, e.getAttribute('data-searchParam'));
                    toast(<SuccessToast body={'Call status updated for Order ' + item.order_name} />, {
                        transition: Slide,
                        hideProgressBar: true,
                        autoClose: 2000,
                    });
                }
                setLoader(false);
            }).catch(e => {
                setLoader(false);
                console.error(e);
            })
        }
        catch (e) {
            setLoader(false);
            console.error(e);
        }
    }
    // const getData = async (
    //     fraud = "",
    //     page = 1,
    //     startDate,
    //     endDate,
    //     searchText,
    //     perams = searchParam
    // ) => {
    //     var rowData = [];
    //     setLoader(true);
    //     if (fraud !== "") {
    //         perams += "&filter=" + fraud
    //     }
    //     try {
    //         await instance.get(`app/order/getOrder?per_page=${per_page}&page=${page}&order_date=${startDate}&end_order_date=${endDate}&search=${searchText}&type=unlabel${perams}`).then((res) => {

    //             //console.log(res);
    //             if (res.status === 200 && Array.isArray(res?.data?.orders)) {
    //                 setRowData(res?.data?.orders || []);
    //                 setOriginalData(res?.data)
    //             }
    //             setLoader(false);
    //         }).catch(e => {
    //             setLoader(false);
    //             console.error(e);
    //             setRowData([]);
    //         })
    //     }
    //     catch (e) {
    //         setLoader(false);
    //         console.error(e);
    //         setRowData([]);
    //     }
    //     return rowData;
    // }

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("page", event.selected + 1)
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }

    const onCellClick = (e) => {
        let selectedITem = e.api.getSelectedRows();
        //console.log(selectedITem.length > 0)
        // setSelectedObject((selectedObject) => [...selectedObject]);
        selectedITem.length > 0 ? (setOpen(true), setSelectedObject([...selectedITem])) : (setOpen(false), setSelectedObject([]));
    }
    const dateChangeEvent = (date) => {
        setStartDate(date.startDate.format('YYYY-MM-DD'));
        setEndDate(date.endDate.format('YYYY-MM-DD'));
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("order_date", date.startDate.format('YYYY-MM-DD'));
        searchParams.set("end_order_date", date.endDate.format('YYYY-MM-DD'));
        searchParams.set("page", 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }
    const searchTextChangeEvent = (e) => {
        e.preventDefault();
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("search", searchText);
        searchParams.set("page", 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }

    const onApplyFilter = (selectionOption, searchTextval = "") => {
        var searchParams = new URLSearchParams(location.search);
        // console.log(selectionOption)
        let url = "";
        Object.keys(selectionOption).map(i => {
            searchParams.set(i, selectionOption[i]);
            url += `&${i}=${selectionOption[i]}`
        })
        searchParams.set("page", 1);
        searchParams.set("search", searchTextval);
        setSearchParam(url);
        localStorage.setItem("searchPeram", url);
        toggleDropdown();
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }

    useEffect(() => {
        var searchParams = new URLSearchParams(location.search);
        let pageNo = searchParams.get("page") || 1;
        let fraudval = searchParams.get("filter") || "";
        let order_date = searchParams.get("order_date") || moment(startDate).format('YYYY-MM-DD');
        let end_order_date = searchParams.get("end_order_date") || moment(endDate).format('YYYY-MM-DD');
        let searchText = searchParams.get("search") || "";
        setSearchText(searchText);
        setFraudVal(fraudval);
        setPageNo(pageNo);
        searchParams.set("page", pageNo);
        if (fraudval === "") {
            searchParams.delete("filter");
        }
        else {
            searchParams.set("filter", fraudval);
        }
        searchParams.set("order_date", order_date);
        searchParams.set("end_order_date", end_order_date);
        searchParams.set("search", searchText);
        let obj = {};
        for (let [key, value] of searchParams.entries()) {
            obj[key] = value;
        }
        delete obj.end_order_date;
        delete obj.order_date;
        delete obj.page;
        // delete obj.search;
        setPreSelectedOption({...obj});        
        // console.log("obj",obj)
        // let url = searchParams.toString() ? '&'+searchParams.toString()  : ""

        // console.log("URLProps", )
        navigate(`${location.pathname}?${searchParams.toString()}`);
        getGridData(searchParams.toString());
    }, [location.search, refreshData])

    const getGridData = async (param) => {
        var rowData = [];
        setLoader(true);
        try {
            await instance.get(`app/order/getOrder?per_page=${per_page}&type=Unlabel&${param}`).then((res) => {

                //console.log(res);
                if (res.status === 200 && Array.isArray(res?.data?.orders)) {
                    setRowData(res?.data?.orders || []);
                    setOriginalData(res?.data)
                }
                setLoader(false);
            }).catch(e => {
                setLoader(false);
                console.error(e);
                setRowData([]);
            })
        }
        catch (e) {
            setLoader(false);
            console.error(e);
            setRowData([]);
        }
        return rowData;
    }


    const handleCallStatusChange = async (data, item) => {
        setLoader(true);
        try {
            await instance.post(`app/order/makeacall`, data).then((res) => {
                if (res.status === 200 && res?.data?.status_code === 200) {
                    closeModal();
                    setRefreshData((prev)=>prev+ 1);
                    toast(<SuccessToast body={res?.data?.message + ' for the Order ' + item.order_name} />, {
                        transition: Slide,
                        hideProgressBar: true,
                        autoClose: 2000,
                    });
                }
                setLoader(false);
            }).catch(e => {
                console.error(e);
                setLoader(false);
            })
        }
        catch (e) {
            console.error(e);
            setLoader(false);
        }
    }

    const closeExportPopup = () => {
        setOpen(false);
        setSelectedObject([])
        gridRef.current.api.deselectAll();
    }
    const cBulkLabelMethod = (item, selectedItem, selectedService) => {
        let orderids = [];
        let ids;
        if (Array.isArray(item)) {
            ids = item.map(i => {
                orderids.push(i.order_id);
                return {
                    "order_id": i.order_id.toString(),
                    "weight": "100",
                    "width": "10",
                    "height": "10",
                    "length": "10"
                }
            })
        }
        else {
            orderids.push(item.order_id);
            ids = [{
                "order_id": item.order_id.toString(),
                "weight": "100",
                "width": "10",
                "height": "10",
                "length": "10"
            }]
        }

        let obj = {
            "service": selectedService,
            "location_id": selectedItem.id.toString(),
            "order_ids": orderids.toString(),
            "orderdata": ids
        }
        const config = {};
        commonServiceMethod("app/createLable/bulk", "post", obj, config, setLoader, (res) => {
            if (res.data.status_code === 200) {
                toast(<SuccessToast body={res.data?.message} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
                setRefreshData((prev)=>prev+ 1);
                // getData(fraudval, pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText,searchParam);
                closeModal();
                setOpen(false);
            }
            else {
                toast(<SuccessToast body={'Something went wrong try again'} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
            }
        });
    }

    const showPopup = () => {
        setPopupData({ popupName: 'courierPartner', data: selectedObject, callBackMethod: cBulkLabelMethod })
    }
    // const gridReadyEvent = () =>{
    //     let allColumnIds = [];
    //     gridRef.current.columnApi.getColumns().forEach((column) => {
    //         allColumnIds.push(column.getId());
    //     });
    //     gridRef.current.columnApi.autoSizeColumns(allColumnIds, true);
    // }
    const fraudFilterChange = (value) => {
        var searchParams = new URLSearchParams(location.search);
        if (value !== fraudval) {
            setFraudVal(value)
            searchParams.set("filter", value);
        }
        else {
            setFraudVal("")
            value = ""
            searchParams.delete("filter");
        }
        setFraudVal(value);
        searchParams.set("page", 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }
    const syncOrder = () => {
        navigate(`${location.pathname}`);
    }
    return (
        <>
            <div className='order-tabs' data-pageNo={pageNo} data-searchParam={searchParam} data-startDate={moment(startDate).format('YYYY-MM-DD')} data-endDate={moment(endDate).format('YYYY-MM-DD')}>

                <Loader showHide={loader} />
                <div className='quick-buttons'>
                    {/* <Link to={'/customers'} className='quickBtn' >Customer</Link>&nbsp;
                <Link to={'/products'} className='quickBtn' >Product</Link>&nbsp; */}

                    {/* {checkAccess(10) && <button className='quickBtn' onClick={() => showModal('quickAccess', 'quickAccess', quickAccessMethod)}> <img src={gridIcon} className="gridIcon"></img> Quick Actions</button>}
                <button className='syncBtn'> <img src={refreshIcon} className="refreshIcon"></img> Sync Orders</button> */}

                    {/* <button className='syncBtn' onClick={() => showModal('courierPartner', 'courierPartner')}>Assign Courier Partner</button>
                <button className='syncBtn' onClick={() => showModal('scanawb', 'scanawb')}>Scan/Paste AWBs</button> */}
                </div>
                <button onClick={() => syncOrder()} className='syncBtn' >Sync</button>
                {open ? <Popup show={{ cBulkLabel: true }} className='all-order' cBulkLabelMethod={showPopup} selecteObject={selectedObject} closePopup={() => { closeExportPopup(); }} /> : null}
                <div className='row filter-section'>
                    <div className="filter-left-container">
                        <div className="form-group">
                            <form onSubmit={searchTextChangeEvent}>
                                <div style={{ position: 'relative' }}>
                                    <span className="icon"><img alt='' src={Search} /></span>
                                </div>
                                <input
                                    type="text"
                                    id="filter-text-box"
                                    placeholder="Search"
                                    className='form-control inputWithIcon'
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </form>
                        </div>
                    </div>
                    <div className='filter-right-container'>
                        <div className='dropdown-dialog-parent me-2'>
                            <div className={` dropdown-dialog ${isOpen ? 'open' : ''}`}>
                                <button type='button' className='btn btn-sm  filter-btn' onClick={toggleDropdown} ><img alt='' style={{ width: 17 }} src={AllFilter} /> Filters</button>
                                <FilterMenu show={isOpen} preSelectedOption={preSelectedOption} filterOptions={filterOptions} onClear={onClearFilter} onApply={onApplyFilter}></FilterMenu>
                            </div>
                        </div>
                        <div className="form-group datepicker-class me-4">
                            <div style={{ position: 'relative' }}>
                                <span className="icon"><img alt='' src={Calandar} /></span>
                            </div>
                            <DateRangePicker
                                className="datepicker-custom"
                                initialSettings={
                                    {
                                        startDate: startDate,
                                        endDate: endDate,
                                        maxDate: moment().toDate(),
                                        showDropdowns: true,
                                        locale: {
                                            format: 'MMM DD, YYYY',
                                        },
                                        ranges: {
                                            Today: [moment().toDate(), moment().toDate()],
                                            Yesterday: [
                                                moment().subtract(1, 'days').toDate(),
                                                moment().subtract(1, 'days').toDate(),
                                            ],
                                            'Last 7 Days': [
                                                moment().subtract(6, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'Last 30 Days': [
                                                moment().subtract(30, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'This Month': [
                                                moment().startOf('month').toDate(),
                                                moment().endOf('month').toDate(),
                                            ],
                                            'Last Month': [
                                                moment().subtract(1, 'month').startOf('month').toDate(),
                                                moment().subtract(1, 'month').endOf('month').toDate(),
                                            ],
                                        },
                                    }}
                                onApply={(e, val) => dateChangeEvent(val, e)}
                            >
                                <input type="text" className="form-control datepicker-range" />
                            </DateRangePicker>
                        </div>
                        <div className='dropdown-dialog-parent'>
                            <OverlayTrigger rootClose={true} trigger="click" placement="bottom" overlay={
                                <Popover id="popover-basic" className='z-index-2000 produc-list'>
                                    <Popover.Body>
                                        <div className=''>
                                            <label className='d-flex p-sku mb-2' htmlFor="green" ><input id='green' checked={fraudval === "green"} style={{marginRight:'10px'}} type='checkbox' name="fraudType" onClick={()=>fraudFilterChange("green")}/> <img src={FraudFilterGreen}  style={{marginRight:'5px'}} /> Low </label>
                                            <label className='d-flex p-sku mb-2'><input style={{marginRight:'10px'}} checked={fraudval === "yellow"} type='checkbox' name="fraudType" onClick={()=>fraudFilterChange("yellow")}/> <img src={FraudFilterYellow}  style={{marginRight:'5px'}} /> Medium </label>
                                            <label className='d-flex p-sku'><input style={{marginRight:'10px'}} checked={fraudval === "red"} type='checkbox' name="fraudType" onClick={()=>fraudFilterChange("red")}/> <img src={FraudFilterRed}  style={{marginRight:'5px'}} /> High </label>
                                        </div>
                                    </Popover.Body>
                                </Popover>
                            }>
                                <p className='btn btn-sm  filter-btn'>
                                <img src={FraudFilter} /> Fraud Filter
                                </p>
                            </OverlayTrigger>
                            {/* <select className='form-control' onChange={(e) => fraudFilterChange(e.target.value)} >
                                <option value='' className='alert-img'><img src={FraudFilter} /> Fraud Filter</option>
                                <option value='green'>Low</option>
                                <option value='yellow'>Medium</option>
                                <option value='red'>red</option>
                            </select> */}
                        </div>
                    </div>
                    <p className='total-count'>Total Count: {originalData?.count}</p>
                </div >
                <DataGridPagination
                    rowData={rowData}
                    columnDefs={columnData}
                    onSelectionChanged={onCellClick}
                    gridref={gridRef}
                    rowSelection={"multiple"}
                    domLayout="autoHeight"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={originalData.per_page}
                    pageCount={originalData.count}
                    forcePage={pageNo-1}
                />
                {popupData.popupName !== "" &&
                    <CallStatus
                        item={popupData.data}
                        show={popupData.popupName}
                        handleSave={popupData.callBackMethod}
                        handleClose={closeModal}
                    />
                }

            </div>
        </>
    );
}

export default UnLabledBody;